import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHTML} from "../helpers/filters";

interface Data {
    paragraphById: {
        fieldTextDemo: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
    }
}

class TextQuery extends Query<Data, {id: string}> {}

const GET_TEXT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphText {
          fieldTextDemo {
            value
            format
            processed
          }
        }
      }
    }
  }
}
`;

const Text = ({id, markComponentLoadedAs}) => (
    <TextQuery asyncMode query={GET_TEXT} variables={{ id }}>
        {({ loading, error, data }) => {
            /* eslint-disable react/no-danger */
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            if (!field.fieldTextDemo || !field.fieldTextDemo.value) return null;

            markComponentLoadedAs(id, true);

            return (
                <div className="container">
                    <div className="text" dangerouslySetInnerHTML={{__html: filterHTML(field.fieldTextDemo.value)}} />
                </div>
            );
        }}
    </TextQuery>
);

Text.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default Text;



// WEBPACK FOOTER //
// ./frontend/components/Text.jsx